/**
 * Content Accordion Two Column JS
 * -----------------------------------------------------------------------------
 *
 * All the JS for the Content Accordion Two Column component.
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin.js';
gsap.registerPlugin( ScrollTrigger, ScrollToPlugin );

( function( app ) {
  const COMPONENT = {
    className: 'content-accordion-two-column',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      document.querySelectorAll( '[data-toggle-group^="section-toggle-"]' ).forEach( ( group ) => {
        const buttons = group.querySelectorAll( '.js-toggle-button' );
        const groupId = group.dataset.toggleGroup.replace( 'section-toggle-', '' );
        const allSections = document.querySelectorAll( `[data-section-${groupId}]` );

        const setActiveButton = ( clickedButton ) => {
          buttons.forEach( ( btn ) => btn.classList.remove( 'active' ) );
          clickedButton.classList.add( 'active' );
        };

        const showOnlyTargetSections = ( targetSelector ) => {
          allSections.forEach( ( section ) => section.classList.remove( 'is-visible' ) );
          document.querySelectorAll( targetSelector ).forEach( ( section ) => section.classList.add( 'is-visible' ) );
        };

        const defaultButton = group.querySelector( '.js-toggle-button[data-toggle-target*="[data-section-"]' );
        if ( defaultButton ) {
          setActiveButton( defaultButton );
          showOnlyTargetSections( defaultButton.getAttribute( 'data-toggle-target' ) );
        }

        buttons.forEach( ( button ) => {
          button.addEventListener( 'click', () => {
            const targetSelector = button.getAttribute( 'data-toggle-target' );
            setActiveButton( button );
            showOnlyTargetSections( targetSelector );
          } );
        } );
      } );

      // Keep for if this component is infact supposed to be a jump link
      // if ( window.innerWidth > 768 ) {
      //   let topOffset = $( 'header' ).height() + 180;
      //   if ( $( 'body.logged-in' ).length > 0 ) {
      //     topOffset += 32;
      //   }

      //   $( '.content-accordion-two__content' ).each( function() {
      //     const jumpLink = '#jump-link-' + $( this ).attr( 'id' );
      //     const tl = gsap.timeline( {
      //       scrollTrigger: {
      //         trigger: this,
      //         start: `top top+=${topOffset}`,
      //         end: `bottom top+=${topOffset}`,
      //         // markers: true,
      //         onEnter: () => $( jumpLink ).addClass( 'active' ),
      //         onLeave: () => $( jumpLink ).removeClass( 'active' ),
      //         onEnterBack: () => $( jumpLink ).addClass( 'active' ),
      //         onLeaveBack: () => $( jumpLink ).removeClass( 'active' ),
      //       },
      //     } );
      //     tl.to( $( jumpLink ), {
      //       addClass: 'active',
      //     } );
      //   } );

      //   $( document ).on( 'click', '.content-accordion-two__content a[href^="#"]', function( e ) {
      //     e.preventDefault();

      //     const targetId = $( this ).attr( 'href' );
      //     const targetEl = document.querySelector( targetId );

      //     if ( targetEl ) {
      //       gsap.to( window, {
      //         duration: 1,
      //         scrollTo: {
      //           y: targetEl,
      //           offsetY: topOffset,
      //         },
      //         ease: 'power2.out',
      //       } );
      //     }
      //   } );
      // }

      // function handleLargeChange( event ) {
      //   if ( event.matches && !$( '.content-accordion-two-content' ).hasClass( 'is-open' ) ) {
      //     $( '.content-accordion-two-content' ).attr( 'aria-hidden', true );
      //   } else if ( !event.matches && !$( '.content-accordion-two-content' ).hasClass( 'is-open' ) ) {
      //     $( '.content-accordion-two-content' ).attr( 'aria-hidden', false );
      //   } else if ( !event.matches && $( '.content-accordion-two__toggle' ).hasClass( 'is-open' ) ) {
      //     $( '.content-accordion-two__toggle' ).trigger( 'click' );
      //     $( '.content-accordion-two-content' ).attr( 'aria-hidden', false );
      //     console.log( 'clicking' );
      //   }
      // }

      // const mobileSize = window.matchMedia( '(max-width: 1024px)' );
      // mobileSize.addEventListener( 'change', handleLargeChange );
    },

    finalize: function() {},
  };

  app.registerComponent( 'content-accordion-two-column', COMPONENT );
} )( app );
